// Paleta central do design system — evita cores hex hardcoded espalhadas pelas views.
export const palette = {
  primary: {
    light: '#7fae95',
    main: '#528e70',
    dark: '#3a6650',
    contrastText: '#ffffff',
  },
  secondary: {
    light: '#5c9bd6',
    main: '#2f6fa8',
    dark: '#1f4d78',
    contrastText: '#ffffff',
  },
  error: {
    main: '#c0392b',
  },
  warning: {
    main: '#e0a800',
  },
  success: {
    main: '#528e70',
  },
  text: {
    primary: '#1a1a1a',
    secondary: '#6b6b6b',
  },
  grey: {
    50: '#fafafa',
    100: '#f2f2f3',
    200: '#e8e8ea',
    300: '#d8d8db',
    400: '#b0b0b5',
    900: '#1a1a1a',
  },
  background: {
    default: '#fafafa',
    paper: '#ffffff',
  },
};

const borderRadius = 10;

export const themeConfig = {
  typography: {
    fontSize: 20,
    useNextVariants: true,
  },
  palette,
  overrides: {
    MuiButton: {
      root: {
        borderRadius,
        textTransform: 'none',
        boxShadow: 'none',
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
      },
    },
    MuiPaper: {
      root: {
        borderRadius,
      },
      elevation1: {
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      },
    },
    MuiDialog: {
      paper: {
        borderRadius,
      },
    },
  },
};
